export default "__VITE_ASSET__2844bff6__"